import { PaginaOperaciones } from '../components/PaginaOperaciones'
import type { Picking } from '../types'

export default function Surtido() {
  return (
    <PaginaOperaciones<Picking>
      titulo="Surtido"
      recurso="surtido"
      llave="id"
      columnas={[
        { campo: 'folio', titulo: 'Folio' },
        { campo: 'pedidoFolio', titulo: 'Pedido' },
        { campo: 'clienteNombre', titulo: 'Cliente' },
        { campo: 'almacenNombre', titulo: 'Almacen' },
        { campo: 'estado', titulo: 'Estado' },
        { campo: 'fecha', titulo: 'Fecha', render: (p) => p.fecha?.split('T')[0] || '-' },
      ]}
      campos={[]}
      valorInicial={{}}
      puedeCrear={false}
      acciones={[
        {
          label: 'Ejecutar',
          endpoint: (p) => `surtido/${p.id}/estado`,
          body: (p) => ({ id: p.id, estado: 'EnEjecucion' }),
          metodo: 'PUT'
        },
        {
          label: 'Autorizar',
          endpoint: (p) => `surtido/${p.id}/estado`,
          body: (p) => ({ id: p.id, estado: 'Autorizado' }),
          metodo: 'PUT'
        }
      ]}
    />
  )
}
